import { ReactPlayerErrorBoundaryRetry } from "@package/ui-apollo-components";
import { useGetMediaQuery } from "@package/ui-gql/index-data-access";
import { useWallProvider } from "@package/ui-wall";
import { getMediaType } from "@package/ui-wall-engine";
import { useEffect, useState } from "react";

type MediaDisplayProps = {
  id?: string;
  classNameMedia?: string;
  forceFit?: boolean;
};

export function MediaDisplay({
  id,
  forceFit,
  classNameMedia,
}: MediaDisplayProps) {
  const provider = useWallProvider();
  const [url, setUrl] = useState<string | undefined>();

  const {
    data: dataMedia,
    error: errorMedia,
    loading: loadingMedia,
  } = useGetMediaQuery({
    variables: {
      id: id ?? "",
    },
    skip: !id,
  });

  useEffect(
    function effectFetchMediaUrl() {
      const fetchMediaUrl = async () => {
        if (id) {
          const url = await provider?.fetchMediaUrl(id);
          if (url) {
            setUrl(url);
          } else {
            console.error(`Media url not found (${id})`);
          }
        }
      };

      fetchMediaUrl();

      return () => {
        setUrl(undefined);
      };
    },
    [id, provider],
  );

  if (loadingMedia) {
    return null;
  }

  if (errorMedia) {
    console.error(errorMedia);
    return null;
  }

  if (!dataMedia?.item) {
    console.error(`Media not found (${id})`);
    return null;
  }

  if (getMediaType(dataMedia.item) === "image") {
    return (
      <img
        className={classNameMedia}
        width="100%"
        height="100%"
        src={url}
        style={{
          height: forceFit ? "100%" : undefined,
          width: forceFit ? "100%" : undefined,
        }}
      />
    );
  }

  return (
    <ReactPlayerErrorBoundaryRetry
      className={classNameMedia}
      width="100%"
      height="100%"
      loop
      muted
      playing
      pip={false}
      url={url}
      onErrorEvent={(error) => {
        console.error("[MediaDisplay]: Media playback error:", error);
      }}
      onMediaStalled={() => {
        console.error(
          "[MediaDisplay]: Media playback stalled, completing video.",
        );
      }}
    />
  );
}
